<template>
  <div class="container text-center leaderboard-wrapper">
    <canvas
      id="firework-canvas"
      v-show="$store.state.slide.type == 'leaderboard' &&
        data.audience && data.audience.totalPoint &&
        data.index == 1 && !showWaitingScreen"
    />
    <div v-if="!showWaitingScreen" class="f-h">
      <div v-if="!isAudienceFormShowing" class="f-h">
        <div v-if="!loading" class="f-h">
          <div v-if="waitingLeadboard" class="f-h">
            <div v-if="!noResult" class="text-center waiting-leadeboard">
              <Loading />Let's see your score and ranking...
            </div>
            <div v-if="noResult" class="padding">
              <h2 v-if="$store.state.slide.title" class="mt-0 text-left slide-title-style">
                {{ $store.state.slide.title }}
              </h2>
              <div class="no-result-yet-text">
                {{ $t("noResultYet") }}
              </div>
            </div>

            <div
              class="audio-control-slide"
              v-if="$store.state.slide.audioLink &&
                $store.state.slide.audioPlayOnAudience &&$store.state.slide.id"
            >
              <AudioControl />
            </div>
          </div>
          <div v-if="!waitingLeadboard" class="f-h fix-content-leaderboard">
            <div
              class="no-win m-b-8"
              v-if="data.audience && !data.lastSlide ||
                data.audience && data.index != 1 && data.lastSlide"
            >
              <div class="bold name-audience" v-if="data.lastSlide">
                {{ $t("betterLuckNextTime") }}
              </div>
              <div class="title-leaderboard" v-if="!data.lastSlide">
                <span :inner-html.prop="$store.state.slide.title || 'Leaderboard' | sanitize(true)" />
                <span class="count-player">
                  {{ $t('players', { msg: countPlayer || '...' }) }}
                </span>
              </div>

              <div class="m-b-8 bold f-s-18" v-if="!data.lastSlide && currentQuiz">
                {{ $t("numberQuestionOfQuizCompleted", {
                  msg: currentQuiz,
                  num: totalQuiz
                }) }}
              </div>
              <div
                v-if="data.index && $store.state.presentation.language == 'en'"
                class="point-audience m-b-8"
              >
                You are in the
                <strong>{{ data.index | countEnglish }}</strong> place out of <strong>{{ data.audiencesCount }}</strong> players
              </div>
              <div
                class="point-audience"
                v-if="data.index && $store.state.presentation.language != 'en' && data.lastSlide"
                v-html="$t(
                  'youAreInPlace',
                  {
                    msg: '<strong>' + data.indexFormat + '</strong>',
                    msg1: '<strong>' + data.audiencesCount + '</strong>',
                  }
                )"
              />
              <div
                v-if="data.audience && data.lastSlide"
                class="point-audience"
                v-html="$t('yourFinalScoreIs', {
                  msg: '<strong>' + data.audience.totalPoint + '</strong>'
                })"
              />
            </div>

            <div class="no-win m-b-8" v-if="!data.audience">
              <div class="bold name-audience" v-if="data.lastSlide">
                {{ $t("betterLuckNextTime") }}
              </div>
              <div
                v-if="data.index && $store.state.presentation.language == 'en'"
                class="point-audience"
              >
                You are in the
                <strong>{{ data.index | countEnglish }}</strong> place out of <strong>{{ data.audiencesCount }}</strong> players
              </div>
              <div
                v-if="data.index && $store.state.presentation.language != 'en'"
                class="point-audience"
                v-html="$t(
                  'youAreInPlace',
                  {
                    msg: '<strong>' + data.indexFormat + '</strong>',
                    msg1: '<strong>' + data.audiencesCount + '</strong>',
                  }
                )"
              />
              <div
                class="point-audience"
                v-html="$t('yourTotalScoreIs', {
                  msg: '<strong>0</strong>'
                })"
              />
            </div>

            <div class="win m-b-8" v-if="data.audience && data.index == 1 && data.lastSlide">
              <div class="avatar-bubble" v-if="data.lastSlide">
                <div class="bubble" />
                <span
                  class="horizontal layout center center-justified animate__pulse animate__animated animate__infinite animate__faster"
                >🏆</span>
              </div>

              <div class="bold name-audience">
                {{ $t("youAreTheWinner") }}
              </div>

              <div
                class="bold"
                style="margin: 16px 0; font-size: 22px;"
              >
                {{ $t('congratulations') }}
                {{ $store.state.audienceEmoji }}
                <profanity-filter :text="$store.state.audienceName" />
              </div>

              <div
                v-if="data.index && $store.state.presentation.language == 'en'"
                class="point-audience"
              >
                You are in the
                <strong>{{ data.index | countEnglish }}</strong> place out of <strong>{{ data.audiencesCount }}</strong> players
              </div>
              <div
                class="point-audience"
                v-if="data.index && $store.state.presentation.language != 'en'"
                v-html="$t(
                  'youAreInPlace',
                  {
                    msg: '<strong>' + data.indexFormat + '</strong>',
                    msg1: '<strong>' + data.audiencesCount + '</strong>'
                  }
                )"
              />

              <div
                class="point-audience"
                v-html="$t('yourFinalScoreIs', {
                  msg: '<strong>' + data.audience.totalPoint + '</strong>'
                })"
              />
            </div>

            <div
              class="audio-control-slide"
              v-if="
                $store.state.slide.audioLink
                  && $store.state.slide.audioPlayOnAudience
                  && $store.state.slide.id
              "
            >
              <AudioControl />
            </div>

            <div class="cta-wrapper" v-if="isLastSlide && data.lastSlide && data.audiencesCount && data.index">
              <QuizSharing
                :position="data.index"
                :total="data.audienceCount"
                :is-team="false"
              />

              <!-- Button CTA -->
              <Buttonv2
                size="lg"
                block
                @click="handleClickOnButtonCTA()"
                v-if="isNotWhiteLabel"
              >
                <span>
                  {{ $t("makeFreeQuiz") }}
                </span>
                <AhaSvg
                  name="arrow-no-tail"
                  view-box="0 0 8 14"
                />
              </Buttonv2>
            </div>

            <!-- Button Next slide -->
            <div class="cta-wrapper" v-if="!isLastSlide && audiencePacing">
              <Buttonv2
                size="lg"
                block
                @click="handleClickNextSlide()"
              >
                <span>{{ $t('nextButton') }}</span>
                <AhaSvg
                  name="arrow-no-tail"
                  view-box="0 0 8 14"
                />
              </Buttonv2>
            </div>

            <ScoreLeaderboardContent
              type="individual"
              :data="scoreLeaderBoard"
              @nextToWaitingScreen="handleWaitingScreen()"
            />
          </div>
        </div>
        <div v-if="loading" class="horizontal layout center center-justified">
          <Loading />
        </div>
      </div>

      <QuizJoinGameForm v-if="isAudienceFormShowing" @joinGame="getResult()" />
    </div>

    <div v-if="showWaitingScreen && !lastSlide">
      <SlideWaiting />
    </div>
  </div>
</template>
<script>
import * as Sentry from '@sentry/vue'

import Constant from '@/constant'
import utils from '@/util'
import EventBus from '@/eventBus'
import { mapState } from 'vuex'

import Config from '@/config'

// UI
import SlideWaiting from '@/components/SlideWaiting.vue'
import Loading from '@/components/Loading.vue'
import AudioControl from '@/components/AudioControl.vue'
import QuizJoinGameForm from '@/components/QuizJoinGameForm.vue'
import QuizSharing from '@/components/QuizSharing.vue'
import AhaSvg from 'storybook-presenter/UI/Svg'
import ScoreLeaderboardContent from '@/components/types/ScoreLeaderboardContent.vue'
import ProfanityFilter from '../utils/ProfanityFilter.vue'
import Buttonv2 from '../UI/Buttonv2.vue'

export default {
  components: {
    AhaSvg,
    SlideWaiting,
    Loading,
    AudioControl,
    QuizJoinGameForm,
    QuizSharing,
    ScoreLeaderboardContent,
    ProfanityFilter,
    Buttonv2,
  },
  data() {
    return {
      audienceName: this.$store.state.audienceName,
      data: {},
      showWaitingScreen: false,
      myReq: null,
      loading: true,
      waitingLeadboard: true,
      noResult: false,
      lastSlide: false,
      currentQuiz: null,
      totalQuiz: null,
      countPlayer: 0,
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      audiencePacing: (state) => state.presentation.audiencePacing,
      presentationID: (state) => state.presentation.id,
      slideActive: (state) => state.slide,
      isNotWhiteLabel: (state) => {
        return state.presentation.planType !== 'white-label'
      },
      isLastSlide: (state) => {
        return state.slide.id === state.presentation.lastSlide
      },
    }),
    isAudienceFormShowing() {
      return !this.$store.state.audienceName || !this.$store.state.isAudienceEmojiDisabled
    },
  },
  destroyed() {
    if (this.myReq) {
      window.cancelAnimationFrame(this.myReq)
    }

    EventBus.$off('answer-quiz')
  },
  mounted() {
    if (this.$store.state.audienceName) {
      this.getResult()
    } else {
      this.loading = false
    }

    EventBus.$on('answer-quiz', (data) => {
      if (this.$store.state.audienceName && this.waitingLeadboard) {
        this.handleDataSuccess(data)
      }
    })
    if (this.$store.state.slide.id === this.$store.state.presentation.lastSlide) {
      this.lastSlide = true
    }

    // Firing confetti effect only available if the canvas element is mounted to the DOM
    const canvas = document.getElementById('firework-canvas')
    const colors = Constant.colorsHex.filter((item, key) => {
      return item && key < 7
    })

    this.startConfettiEffect = utils.setupConfettiEffect(canvas, { resize: true },
      {
        startVelocity: 5,
        spread: 360,
        ticks: 100,
        decay: 0.98,
        particleCount: 40,
        shapes: ['circle'],
        colors,
        zIndex: 100,
      })
  },
  methods: {
    handleWaitingScreen() {
      this.showWaitingScreen = true
    },
    _createDataShowListScore(doc) {
      let total = 0
      if (doc.audiences.length) {
        total = doc.audiences[0].t
      }

      doc.audiences.forEach((item, key) => {
        item.color = Constant.colors[key % 30]
        item.oldPercent = (item.t / total) * 100 || 1
      })

      this.scoreLeaderBoard = doc.audiences
      this.countPlayer = doc.audiences.length
    },
    async getResult() {
      this.loading = true

      try {
        let doc
        if (this.$store.state.presentation.audiencePacing) {
          const res = await this.$http.post(Config.api.createLeaderboard, {
            slideId: this.$store.state.slide.id,
          })
          doc = res.body
        } else {
          const url = this.$store.state.slide.cacheLeaderboardUrl
          if (!url) {
            this.loading = false
            this.noResult = true
            return
          }
          const res = await this.$http.get(url)
          doc = res.body
        }
        this.loading = false

        if (!doc.id) {
          doc.audiences = []
        }
        if (!doc.audiences.length) {
          this.noResult = true
          return
        }
        this.handleDataSuccess(doc)
        this.currentQuiz = doc.currentQuiz
        this.totalQuiz = doc.totalQuiz
        this._createDataShowListScore(doc)
      } catch (err) {
        this.noResult = true
        this.loading = false
        Sentry.captureException(err)
      }
    },

    handleDataSuccess(doc) {
      if (!doc.id || doc.loading) {
        this.waitingLeadboard = true
        return
      }
      this.waitingLeadboard = false
      const index = doc.audiences.findIndex((item) => {
        return item.a === this.audienceId
      })

      if (index !== -1) {
        const audience = doc.audiences[index]
        this.data.audience = {
          audience: this.audienceId,
          audienceEmoji: this.$store.state.audienceEmoji,
          audienceName: this.$store.state.audienceName,
          index: audience.i,
          totalPoint: audience.t,
        }
        this.data.index = audience.i
        this.data.audience.totalPoint = utils.numberWithCommas(this.data.audience.totalPoint)
        this.data.indexFormat = utils.numberWithCommas(audience.i)
      }
      this.data.lastSlide = doc.lastSlide
      this.data.audienceCount = doc.audiences.length
      this.data.audiencesCount = utils.numberWithCommas(doc.audiences.length)
      if (this.data.lastSlide) {
        this.$store.state.slide.finalLeaderboard = true
      }

      if (
        this.data.lastSlide &&
        this.data.audience &&
        this.data.audience.totalPoint &&
        this.data.index === 1
      ) {
        const self = this
        if (!self.startConfettiEffect) {
          return
        }

        let start = null

        // eslint-disable-next-line
        function step(timestamp) {
          if (!start) start = timestamp
          const progress = timestamp - start
          if (progress > 1200) {
            start = null
            self.startConfettiEffect({
              x: Math.random(),
              y: Math.random() - 0.3,
            })
          }
          self.myReq = window.requestAnimationFrame(step)
        }
        self.myReq = window.requestAnimationFrame(step)
      }
    },

    handleClickOnButtonCTA() {
      window.open(utils.generateButtonCTAURL(this.presentationID, this.slideActive, 'leaderboard_CTA'), '_blank')
      utils.trackGAButtonCTA(this.presentationID, this.slideActive)
    },

    handleClickNextSlide() {
      EventBus.$emit('skipSlide')
    },
  },
}
</script>

<style lang="scss" scoped>
.cta-wrapper {
  width: 100%;
  max-width: 400px;
  margin: 16px auto;
}
</style>
